import { _axios } from '@/plugins/axios';

const FileServerResource = '/api/v1/fileServer';

export default {
  all: () => _axios.get(`${FileServerResource}/all`),
  delete: uuid => _axios.post(`${FileServerResource}/delete/${uuid}`, uuid),
  create: fileServerName => _axios.post(`${FileServerResource}/create`, fileServerName),
  getById: uuid => _axios.get(`${FileServerResource}/get/${uuid}`),
  getSubTypes: () => _axios.get(`${FileServerResource}/subTypes`),
  getTypes: () => _axios.get(`${FileServerResource}/types`),
};
